export const limit = 4;
export const pageSize = 6;
export const itemsCountPerPage = 6;
export const pageRangeDisplayed = 5;

export const cdnUrl = "https://i2.wp.com/uat.webuters.com/wp-content";
//export const imageBaseUrl =  'https://i2.wp.com/uat.webuters.com/wp-content'
export const imageBaseUrl =  'https://i2.wp.com/cms.webuters.com/wp-content'